import React, { FC } from 'react';
import { IonModal, IonList, IonItem, IonLabel, IonListHeader, IonButton } from '@ionic/react';
import { injectIntl, FormattedMessage } from 'react-intl';
import isAuthenticated from '../../components/Authentication/Authenticated';

import classes from './DeleteModal.module.css';
import { RouteComponentProps } from 'react-router';

import Messages from '../DeleteModal/DeleteModal.messages';

interface DeleteModalProps extends RouteComponentProps {
	title: any;
	isOpen: boolean;
	onConfirm: any;
	onDismiss: any;
	itemName: string;
}

const DeleteModalOrgDeviceError: FC<DeleteModalProps> = (props: any) => {
	const onDismissModal = () => {
		props.onDismiss();
	};

	return (
		<IonModal
			cssClass={classes.addModal}
			isOpen={props.isOpen}
			swipeToClose
			show-backdrop
			onDidDismiss={onDismissModal}
		>
			<IonList className={classes.modalContent}>
				<IonItem lines="none" className={classes.msgContainer}>
					<div className={classes.headerContainer}>
						<IonLabel className={classes.headerTitle}>{props.title}</IonLabel>
						<IonLabel className={classes.msg}>
							<FormattedMessage
								{...Messages.errorMsg}
								values={{ item: props.itemName, br: <br /> }}
							/>
						</IonLabel>
					</div>
				</IonItem>
				<IonItem lines="none" className={classes.btnContainer}>
					<IonButton
						expand="block"
						shape="round"
						size="large"
						fill="outline"
						className={classes.cancelBtn}
						onClick={props.onDismiss}
					>
						<FormattedMessage {...Messages.cancel} />
					</IonButton>
				</IonItem>
			</IonList>
		</IonModal>
	);
};

export default injectIntl(isAuthenticated(DeleteModalOrgDeviceError));
